import comp from "./ImageDropzoneV2";
export default comp;
